export class Maintenance {
    id: number;
    name: string;
    description: string;
    archivedDate?: Date;

    constructor(
        id: number,
        name: string,
        description: string,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.archivedDate = archivedDate;
    }

    static empty(): Maintenance {
        return { id: 0, name: '', description: '' };
    }

}